import { render, staticRenderFns } from "./AboutScreen.vue?vue&type=template&id=62e6313a"
import script from "./AboutScreen.vue?vue&type=script&lang=ts"
export * from "./AboutScreen.vue?vue&type=script&lang=ts"
import style0 from "./AboutScreen.vue?vue&type=style&index=0&id=62e6313a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports